import { useEffect, useRef } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { FixedClickableTextPanel } from "../../ClickableText/FixedClickableTextPanel";

import styles from "./GeneralInstructionsComponent.module.scss";

interface IGeneralInstructionsComponentProps {
    generalInstructions: string;
    isClickableTextPanelOpen: boolean;
    isReadonly?: boolean;
    onTextChangeCallback: (value: string) => void;
    onSaveFieldBlur?: () => void;
    onCloseClickableText: () => void;
    onOpenClickableText: () => void;
    shouldTriggerResize?: boolean;
}

export function GeneralInstructionsComponent(props: IGeneralInstructionsComponentProps): JSX.Element {
    const { getText } = useTranslation();

    const generalInstructionstId: string = "generalInstructionstId";
    const noteLegth = props.generalInstructions?.length ?? 0;
    const maxNoteLengthLimit: number = 800;
    const noteRef = useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (props.shouldTriggerResize && noteRef.current) {
            const resizeObserver = new ResizeObserver(() => {
                $(window).trigger("resize");
            });

            resizeObserver.observe(noteRef.current);

            return () => {
                resizeObserver.disconnect();
            };
        }
    }, [props.shouldTriggerResize]);

    return (
        <div className={styles.noteContainer}>
            <div className={styles.prescriptionNote}>
                <div>
                    <label className={`form-label ${styles.noteFont}`}>{getText("GeneralInstructionsLabel")}</label>
                </div>
                <textarea
                    id={generalInstructionstId}
                    data-cy="prescription-general-instructions"
                    className={`form-control ${styles.notesTextbox}`}
                    rows={1}
                    value={props.generalInstructions ?? ""}
                    maxLength={maxNoteLengthLimit}
                    onChange={(e: any) => {
                        if (e.target.value.length > maxNoteLengthLimit) {
                            sessionStore.showPopup({
                                title: getText("ErrorMLabel"),
                                content: getText("MaxCharacterLimitErrorLabel")
                            });
                            return;
                        }
                        props.onTextChangeCallback(e.target.value);
                    }}
                    onBlur={() => props.onSaveFieldBlur?.()}
                    disabled={!!props.isReadonly}
                    ref={noteRef}
                />
                <div>
                    <div className={styles.notesFooter}>
                        <div>
                            <label className={styles.counter} data-cy="counter-label">
                                {`${noteLegth}/${maxNoteLengthLimit}`}
                            </label>
                        </div>
                        <FixedClickableTextPanel
                            cssClass="text-helper-container"
                            context="PrescriptionRenewalNotes"
                            inputElementId={generalInstructionstId}
                            isClickableTextPanelOpen={props.isClickableTextPanelOpen}
                            onClickableTextPanelOpen={() => props.onOpenClickableText()}
                            onClickableTextPanelClose={() => props.onCloseClickableText()}
                            isLinkDisabled={!!props.isReadonly}
                            isAboveLabel
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
